'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isPrimitive = {};

exports.__exports = isPrimitive;
